import styled from "styled-components";
import { palette, size } from "styled-theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 60px 0;

  .approved-title {
    text-align: center;
  }

  @media only screen and (max-width: ${size("M")}) {
    padding: 0;
  }

  .animated-gif-thumb {
    max-width: 80px;
  }

  .esign-content {
    margin-top: 20px;
    text-align: center;
    padding: 0 10px;

    span {
      color: ${palette("color", 15)};
      font-weight: bold;
    }
  }

  .personal-loan-info {
    @media only screen and (max-width: ${size("M")}) {
      padding-right: 50px;
    }

    @media only screen and (max-width: ${size("S")}) {
      padding-right: 0;
    }

    p {
      @media only screen and (max-width: ${size("S")}) {
        text-align: center;
      }
    }
  }

  .esign-button {
    margin: 20px 0 0;
    width: 250px;
  }
  .loan-amount-mobile,
  .loan-term-mobile,
  .credit-limit-mobile,
  .repayment-amount-mobile {
    display: none;
    color: ${palette("color", 15)};
    font-weight: bold;
    text-align: left;
    padding: 0;

    @media only screen and (max-width: ${size("S")}) {
      display: block;
    }
  }

  .loan-terms {
    width: 70%;
    margin: 20px 0px;
    border-top: 1.7px solid ${palette("tracking", 5)};
    border-bottom: 1.7px solid ${palette("tracking", 5)};
    text-align: left;
    display: flex;
    justify-content: center;

    @media only screen and (max-width: ${size("S")}) {
      padding: 0;
      text-align: left;
    }
  }

  .loan-terms-inner {
    width: 80%;
    padding: 20px 60px;
    display: flex;
    justify-content: space-between;

    @media only screen and (max-width: ${size("M")}) {
      width: 100%;
      padding: 20px 2px;
      justify-content: center;
    }
  }

  .values-column {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    text-align: left;

    @media only screen and (max-width: ${size("S")}) {
      padding: 0;
      align-items: flex-end;
    }

    p {
      text-align: left;
    }
  }

  .repayment-amount {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;

    @media only screen and (max-width: ${size("S")}) {
      align-items: center;
    }

    p {
      text-align: left;

      @media only screen and (max-width: ${size("S")}) {
        text-align: center;
      }
    }
  }

  .repayment-amount-value {
    color: ${palette("color", 15)};
    font-weight: bold;
    text-align: left;
    display: flex;
    align-items: flex-start;

    @media only screen and (max-width: ${size("S")}) {
      display: none;
    }
  }

  .loan-amount-value,
  .credit-limit-value,
  .loan-term-value,
  .loc-values {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    color: ${palette("color", 15)};
    font-weight: bold;
    text-align: left;

    @media only screen and (max-width: ${size("S")}) {
      display: none;
    }
  }

  h2 {
    color: ${palette("color", 15)};
    font-weight: bold;
    padding-top: 10px;
    text-align: center;
  }

  p {
    text-align: left;
    padding-top: 10px;
  }
`;
